var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["shipping/pdp-collection-points-info-icon.j2"] = require( "shipping/pdp-collection-points-info-icon.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/shipping/pdp-collection-points-message.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "product/templates/shipping/pdp-collection-points-message.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("staticUrl")) {
var t_4 = t_1.staticUrl;
} else {
cb(new Error("cannot import 'staticUrl'")); return;
}
context.setVariable("staticUrl", t_4);
var t_5;
t_5 = (lineno = 1, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.configs.collectionPointEnabled",false]));
frame.set("siteCollectionPointEligible", t_5, true);
if(frame.topLevel) {
context.setVariable("siteCollectionPointEligible", t_5);
}
if(frame.topLevel) {
context.addExport("siteCollectionPointEligible", t_5);
}
output += "\n";
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"skuInfo")),"allSkusCollectionPointEligible") || runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"selectedSku")),"sku")),"collectionPointEligible");
frame.set("skuCollectionPointEligible", t_6, true);
if(frame.topLevel) {
context.setVariable("skuCollectionPointEligible", t_6);
}
if(frame.topLevel) {
context.addExport("skuCollectionPointEligible", t_6);
}
if(runtime.contextOrFrameLookup(context, frame, "siteCollectionPointEligible")) {
output += "<div class=\"c-product-details__collection-points\">";
if(runtime.contextOrFrameLookup(context, frame, "skuCollectionPointEligible")) {
output += "<a href=\"#cp-info\" class=\"c-product-details__collection-points-link\">\n\n                <span>\n                    ";
output += runtime.suppressValue((lineno = 13, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["collection_points-item-available"])), env.opts.autoescape);
output += "\n                </span>";
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/shipping/pdp-collection-points-message.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "</a>";
})});
}
else {
output += "<a href=\"#bopis-restricted\" class=\"c-product-details__collection-points-link\">\n\n                <span>\n                    ";
output += runtime.suppressValue((lineno = 24, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["collection_points-item-ineligible"])), env.opts.autoescape);
output += "\n                </span>";
env.getTemplate("shipping/pdp-collection-points-info-icon.j2", false, "product/templates/shipping/pdp-collection-points-message.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "</a>";
})});
}
output += "</div>";
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/shipping/pdp-collection-points-message.j2"] , dependencies)